module.exports = __webpack_public_path__ + "static/r3c1-7d0376547f314266f0dd2b3f2b4f9710.png";